import {RiReactjsLine} from "react-icons/ri";
import {FaServer} from "react-icons/fa";
import {AiFillAppstore} from "react-icons/ai";

const data = [
    {
        id: 1,
        icon: <RiReactjsLine/>,
        title: "Frontend Development",
        desc: "In frontend development, I bring a strong focus on crafting user-friendly and visually appealing interfaces for websites and applications, ensuring a seamless and engaging user experience, including mobile phones, tablets, and desktop.",
    },
    {
        id: 2,
        icon: <FaServer/>,
        title: "Backend Development",
        desc: "I bring a strong focus on building robust, efficient, and secure server-side systems that power the functionality of websites and applications, ensuring data handling, processing, and storage is optimized for performance and reliability.",
    },
    {
        id: 3,
        icon: <AiFillAppstore/>,
        title: "App Development",
        desc: "In app development, I focus on creating feature-rich and user-friendly mobile applications that provide a seamless and enjoyable experience for users, while also ensuring the efficient utilization of resources and integration with various platforms and services.",
    },
];

export default data;
